import { render, staticRenderFns } from "./LayoutFirst.vue?vue&type=template&id=1564989e"
import script from "./LayoutFirst.vue?vue&type=script&lang=js"
export * from "./LayoutFirst.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports